<template>
  <div>
    <b-skeleton
        size="is-large"
        height="340px"
        :active="!isFinished && color !== null && !imageLoaded">

    </b-skeleton>


    <div class="product-card" v-if="isLoaded && categoria === true && color !== null">
      <div class="product-card-img">
        <!--        <img-->
        <!--          :src="'/media/prodotti-gruppi/' + getPath(colori) + '.jpg'"-->
        <!--          :alt="colori.codice"-->
        <!--        />-->
        <image-elm :elm="colori" @imgLoaded="imgLoaded"/>
      </div>
      <div class="product-card-desc">
        <p v-if="colori.category" class="product-cat-art">
          <cod-elm v-if="color !== null" :elm="product"/>

        </p>
        <p class="product-cat-cod">
          {{ product.family.descrizione }}
        </p>
        <p v-if="getLocation() === 'family'" class="product-cat">
          {{ colori.category.descrizione }}
        </p>
        <p v-if="product.color" class="product-color">{{ product.color.descrizione }}</p>
      </div>
      <div class="product-card-btns">
        <a
            v-if="product.color"
            class="link-ret green scopri"
            :href="
            url(
              '/b2b/product/' +
                product.codice
            )
          "
        >{{ trans.get("b2b.explore") }}</a
        >
        <a
            v-else
            class="link-ret green scopri"
            :href="
            url(
              '/b2b/category/' +
                product.cod_famiglia +
                '/' +
                product.cod_categoria
            )
          "
        >{{ trans.get("b2b.explore") }}</a
        >
        <a
            @click="
            $store.commit('showAcquistoVeloce', {
              status: true,
              macro: product.cod_macrofamiglia,
              family: product.cod_famiglia,
              category: product.cod_categoria,
              color: color,
              //todo diversificazione con colore
            })
          "
            class="cart link-ret black btn btn-my-primary flex-shrink-1"
        >
          <img src="\media\icons\svg\cart1.svg" alt="carrello"/>
        </a>

        <!--      <a v-if="customer" class="link-ret dark-gray cart">Cart</a>-->
      </div>
    </div>
    <div class="product-card" v-if="isLoaded && categoria === false">
      <div class="product-card-img">
        <!--        <img-->
        <!--          :src="'/media/prodotti-gruppi/' + getPath(colori) + '.jpg'"-->
        <!--          :alt="colori.codice"-->
        <!--        />-->
        <image-elm :elm="product"/>
      </div>
      <div class="product-card-desc">
        <p class="is-uppercase">
          <cod-elm :elm="product"/>

        </p>
        <p v-if="product.cod_art" class="product-cat mt-2">

          {{ product.des_estesa }}
        </p>

      </div>
      <div class="product-card-btns">
        <a
            v-if="product"
            class="link-ret green scopri"
            :href="
            url(
              '/b2b/uncat/' +
                product.cod_famiglia +
                '/' +
                product.slug
            )
          "
        >{{ trans.get("b2b.explore") }}</a
        >

        <a
            @click="
            $store.commit('showAcquistoVeloce', {
              status: true,
              macro: product.cod_macrofamiglia,
              family: product.cod_famiglia,
              category: product.cod_categoria,
              color: color,
              cod_art: (categoria) ? null : product.cod_art,
             })
          "
            class="cart link-ret black btn btn-my-primary flex-shrink-1"
        >
          <img src="\media\icons\svg\cart1.svg" alt="carrello"/>
        </a>

        <!--      <a v-if="customer" class="link-ret dark-gray cart">Cart</a>-->
      </div>
    </div>
    <div class="product-card" v-if="isLoaded && categoria === true && color === null">
      <div class="product-card-img">
        <!--        <img-->
        <!--          :src="'/media/prodotti-gruppi/' + getPath(colori) + '.jpg'"-->
        <!--          :alt="colori.codice"-->
        <!--        />-->
        <image-elm :elm="colori" @imgLoaded="imgLoaded"/>
      </div>
      <div class="product-card-desc">
        <p v-if="colori.category" class="product-cat-art">
          <cod-elm v-if="color !== null" :elm="product"/>

        </p>
        <p class="product-cat-cod">
          {{ product.family.descrizione }}
        </p>
        <p v-if="getLocation() === 'family'" class="product-cat">
          {{ colori.category.descrizione }}
        </p>
        <p v-if="product.color" class="product-color">{{ product.color.descrizione }}</p>
      </div>
      <div class="product-card-btns">
        <a
            class="link-ret green scopri"
            :href="
            url(
              '/b2b/articles/' +
                product.cod_famiglia +
                '/' +
                product.cod_categoria + '/SC'
            )
          "
        >{{ trans.get("b2b.explore") }}</a
        >
        <a
            @click="
            $store.commit('showAcquistoVeloce', {
              status: true,
              macro: product.cod_macrofamiglia,
              family: product.cod_famiglia,
              category: product.cod_categoria,
              color: color,
              //todo diversificazione con colore
            })
          "
            class="cart link-ret black btn btn-my-primary flex-shrink-1"
        >
          <img src="\media\icons\svg\cart1.svg" alt="carrello"/>
        </a>

        <!--      <a v-if="customer" class="link-ret dark-gray cart">Cart</a>-->
      </div>
    </div>
    <!--    <p v-if="color === null" class="col-md-12">-->
    <!--      Redirecting to article...-->
    <!--    </p>-->


  </div>
</template>

<script>
export default {
  components: {},

  props: {
    product: {
      type: Object,
    },
    family: {
      type: String,
    },
    color: {
      type: String,
    },
    customer: {
      type: Boolean,
    },
    categoria: {
      type: Boolean,
    },
  },
  data: function () {
    return {
      isLoaded: false,
      isFinished: false,
      colori: null,
      path: null,
      imageLoaded: false,
    };
  },
  created() {
    // if (this.color === null) {
    //   this.redirectNoColor()
    // }
  },
  mounted() {
    if (this.categoria) {
      this.getColors();
    } else {
      this.isLoaded = true
      this.isFinished = true
    }

  },
  methods: {
    imgLoaded(values) {
      this.imageLoaded = values
    },
    redirectNoColor() {
      window.location.replace(window.location.origin + '/b2b/articles/' + this.family + '/' + this.product.cod_categoria + '/SC')
    },
    getLocation() {
      let path = window.location.pathname.split('/')
      return path[path.length - 2]
    },
    getPath: function (prodotto) {
      let path = "";
      path += prodotto.cod_macrofamiglia;
      path += "-";
      path += prodotto.cod_famiglia;
      path += "-";
      path += prodotto.cod_categoria;
      if (this.color !== undefined) {
        path += "-" + this.color;
      } else {
        path += "-" + prodotto.codColore;
      }

      return path;
    },
    getColors: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: this.product.category.codice,
          famiglia: this.family,
          type: "colori_art",
        },
      })
          .then((res) => {
            //console.log(res.data.family)
            if (res.data.family.cod_colore) {
              if (
                  this.product.category.codice === res.data.family.cod_categoria
              ) {
                if (this.product.cod_colore) {
                  this.colori = {
                    ...this.product,
                    color: {
                      codice: this.product.cod_colore
                    },
                  };
                } else {
                  this.colori = {
                    ...this.product,
                    color: {
                      codice: res.data.family.cod_colore
                    },
                  };
                }
              }
            } else {
              this.colori = this.product
            }
            this.isLoaded = true;
            this.isFinished = true
          })
          .catch((err) => {
            this.isFinished = true
            // this.$store.commit("add_message", {
            //   type: "error",
            //   message: err.response.data.message,
            // });
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-card {
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 290px;
  margin: 0 auto;
  min-height: 340px;

  .product-card-img {
    min-height: 179px;

    img {
      object-fit: contain;
    }
  }

  .product-card-desc {
    margin-top: 13px;
    padding-left: 30px;

    .product-cat-art {
      text-transform: uppercase;
      margin-bottom: 5px;
    }

    .product-cat-cod {
      font-size: 14px;
      text-transform: lowercase;

      &:first-letter {
        text-transform: uppercase;
      }
    }

    .product-id {
      font-size: 14px;
    }

    .product-cat,
    .product-micro {
      font-size: 14px;
      text-transform: lowercase;


      &:first-letter {
        text-transform: capitalize;
      }
    }

    .product-color {
      text-transform: lowercase;
      font-size: 12px;

      &:first-letter {
        text-transform: uppercase;
      }
    }
  }

  .product-card-btns {
    display: flex;
    width: 100%;
    padding: 0 15px;
    margin-top: auto;

    .scopri {
      width: 100%;
      height: 40px;
      margin-right: 8px;
      margin-bottom: 20px;
    }

    .cart {
      height: 40px;
      width: 80px;
      margin-bottom: 20px;

      &:after {
        border: none;
      }
    }
  }
}
</style>
